import React from "react";
import SDCSubmission from "./SDCSubmission";

const SDCSubmissionData = (SDCData) => {
  return (
    <SDCSubmission
      key={SDCData.id}
      id={SDCData.id}
      companyName={SDCData.companyName}
      otherCompanyName={SDCData.otherCompanyName}
      companyAddress={SDCData.companyAddress}
      companyPhone={SDCData.companyPhone}
      companyEmail={SDCData.companyEmail}
      companyLogo={SDCData.companyLogo}
      name={SDCData.name}
      supportedBy={SDCData.supportedBy}
      civilDesign={SDCData.civilDesign}
      otherCivil={SDCData.otherCivil}
      mechDesign={SDCData.mechDesign}
      otherMech={SDCData.otherMech}
      elecDesign={SDCData.elecDesign}
      otherElec={SDCData.otherElec}
      packageDesign={SDCData.packageDesign}
      otherPackage={SDCData.otherPackage}
      undergroundPipeline={SDCData.undergroundPipeline}
      otherUndergroundPipeline={SDCData.otherUndergroundPipeline}
      dateOfLastReview={SDCData.dateOfLastReview}
    />
  );
};

const SDCList = (props) => {
  let sorted = props.SDCData;

  if (sorted === []) {
    return (
      <h2 className="text-center">
        Found no results matching selected filters
      </h2>
    );
  }

  if (props.filteredSupplier) {
    sorted = sorted.filter((data) => {
      return data.companyName === props.filteredSupplier;
    });
  }

  if (props.filteredCivil) {
    sorted = sorted.filter((data) => {
      return (
        data.civilDesign.includes(props.filteredCivil) ||
        data.otherCivil === props.filteredCivil
      );
    });
  }

  if (props.filteredMech) {
    sorted = sorted.filter((data) => {
      return (
        data.mechDesign.includes(props.filteredMech) ||
        data.otherMech === props.filteredMech
      );
    });
  }

  if (props.filteredElec) {
    sorted = sorted.filter((data) => {
      return (
        data.elecDesign.includes(props.filteredElec) ||
        data.otherElec === props.filteredElec
      );
    });
  }

  if (props.filteredUndergroundPipe) {
    sorted = sorted.filter((data) => {
      return (
        data.undergroundPipeline.includes(props.filteredUndergroundPipe) ||
        data.otherUndergroundPipeline === props.filteredUndergroundPipe
      );
    });
  }

  if (props.filteredPackageSystem) {
    sorted = sorted.filter((data) => {
      return (
        data.packageDesign.includes(props.filteredPackageSystem) ||
        data.otherPackage === props.filteredPackageSystem
      );
    });
  }

  if (sorted.length !== 0) {
    return <ul>{sorted.map((SDCData) => SDCSubmissionData(SDCData))}</ul>;
  } else {
    return (
      <h2 className="text-center">
        Found no results matching selected filters
      </h2>
    );
  }
};

export default SDCList;
